import { Controller } from "@hotwired/stimulus"

const PUBLIC_MODE = "public"
const PRIVATE_MODE = "private"
const BROADCAST_MODE = "broadcast"

export default class extends Controller {
  static values = {
    tapFeedSpaceId: String
  }

  static targets = [
    "chatTypeRadioButtons",
    "communitySpaceFormGroup",
    "title",
    "stepCounter",
    "submitButton"
  ]

  connect() {
    this.updateFormForSelectedMode(true)

    this.getChatTypeRadioButtons().forEach(radioButton => {
      radioButton.addEventListener("change", () => {
        this.updateFormForSelectedMode(false)
      })
    })
  }

  updateFormForSelectedMode(isInitializing = false) {
    const mode = this.getSelectedChatCreationMode()

    if (mode === PUBLIC_MODE) {
      this.handlePublicMode()
    } else if (mode === PRIVATE_MODE) {
      this.handlePrivateMode(isInitializing)
    } else if (mode === BROADCAST_MODE) {
      this.handleBroadcastMode(isInitializing)
    }
  }

  handlePublicMode() {
    this.setCommunitySpaceValue(this.tapFeedSpaceIdValue)
    this.hideCommunitySpaceFormGroup(true)
    this.setTitleText("Create Group Chat")
    this.hideStepCounter(false)
    this.setSubmitButtonText("Next")
  }

  handlePrivateMode(isInitializing) {
    if (!isInitializing) {
      this.clearCommunitySpaceValue()
    }
    this.hideCommunitySpaceFormGroup(false)
    this.setTitleText("Create Group Chat")
    this.hideStepCounter(false)
    this.setSubmitButtonText("Next")
  }

  handleBroadcastMode(isInitializing) {
    if (!isInitializing) {
      this.clearCommunitySpaceValue()
    }
    this.hideCommunitySpaceFormGroup(false)
    this.setTitleText("Create Broadcast Chat")
    this.hideStepCounter(true)
    this.setSubmitButtonText("Create Chat")
  }

  getSelectedChatCreationMode() {
    const checkedRadioButton = Array.from(this.getChatTypeRadioButtons()).find(radioButton => {
      return radioButton.checked
    })

    return checkedRadioButton ? checkedRadioButton.value : null
  }

  setCommunitySpaceValue(value) {
    const select = this.findCommunitySpaceSelect()
    if (!select) return

    if (select.tomselect) {
      select.tomselect.setValue(value, false)
    } else {
      select.value = value
    }
  }

  clearCommunitySpaceValue() {
    const select = this.findCommunitySpaceSelect()
    if (!select) return

    if (select.tomselect) {
      select.tomselect.clear(false)
    } else {
      select.value = ""
    }
  }

  findCommunitySpaceSelect() {
    return this.communitySpaceFormGroupTarget.querySelector("select")
  }

  hideCommunitySpaceFormGroup(isHide) {
    this.communitySpaceFormGroupTarget.classList.toggle("hidden!", isHide)
  }

  hideStepCounter(isHide) {
    this.stepCounterTarget.classList.toggle("hidden!", isHide)
  }

  setTitleText(text) {
    this.titleTarget.textContent = text
  }

  setSubmitButtonText(text) {
    this.submitButtonTarget.textContent = text
  }

  getChatTypeRadioButtons() {
    return this.chatTypeRadioButtonsTarget.querySelectorAll("input[type='radio']")
  }
}
